import {PubSub} from '@mamdev/cad.static-next-lib';

interface HistoryState {
  headcrumb: {
    brainZone: string;
    componentPath: string;
    name: string;
    url: string;
  }[];
}

export interface StateReplacedData {
  url: string;
  state: HistoryState;
}

/**
 * Helper functions built around the history API.
 */
export class HistoryService {
  static replaceState(state: HistoryState, url: string) {
    window.history.replaceState(state, '', url);

    PubSub.publish('history:stateReplaced', {
      url: url,
      state: state
    } as StateReplacedData);
  }
}
